import { PosthogHelper } from '~/helpers/PosthogHelper';
import { AnalyticsEventNames } from '~/tracking';

import WhiskeyExitImg from '../../../assets/img/track-record/dark/whiskey-exit.svg';
import { Button } from '~/vinovest-design-system/components';
import { baseRoutes } from '~/routes/base';
import Image from 'next/image';
import { GetStarted } from './components/GetStarted/GetStarted';
import styles from './TrackRecordPageDark.module.scss';
import { TrackRecordSection } from './components/TrackRecordSection/TrackRecordSection';

export const TrackRecordPageDark = () => {
    const WhiskeyExitImage = WhiskeyExitImg;
    const reports = [
        {
            year: '2024',
            q1Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q1-2024',
            q2Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q2-2024',
            q3Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q3-2024',
            q4Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q4-2024'
        },
        {
            year: '2023',
            q1Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q1-2023',
            q2Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q2-2023',
            q3Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q3-2023',
            q4Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q4-2023'
        },
        {
            year: '2022',
            q1Link: 'https://www.vinovest.co/static/media/Quarterly_Report_Q1_2022.e339d191.pdf',
            q2Link: 'https://www.vinovest.co/static/media/Quarterly_Report_Q2_2022.932b68c3.pdf',
            q3Link: 'https://www.vinovest.co/static/media/Quarterly_Report_Q3_2022.6ba2d11a.pdf',
            q4Link: 'https://www.vinovest.co/blog/vinovest-quarterly-report-q4-2022'
        },
        {
            year: '2021',
            q1Link: 'https://www.vinovest.co/static/media/Q1_2021-Report.570a6a74.pdf',
            q2Link: 'https://www.vinovest.co/static/media/Q2_2021_Report__optimized_.a08413a3.pdf',
            q3Link: 'https://www.vinovest.co/static/media/Q3_2021_Report.53f09875.pdf',
            q4Link: 'https://www.vinovest.co/static/media/Q4_2021_Report.b5e036f2.pdf'
        },
        {
            year: '2020',
            q1Link: 'https://www.vinovest.co/static/media/5e975813439e9048fddc843a_Vinovet-Q1-report-1.6a57a3aa.pdf',
            q2Link: 'https://www.vinovest.co/static/media/5f2102df61c7887a86d9ffd3_VinovestQ2report.48e3e0ea.pdf',
            q3Link: 'https://www.vinovest.co/static/media/5f86215c0ca5ad7d0bba60d9_Vinovest-Q3.182203ba.pdf',
            q4Link: 'https://www.vinovest.co/static/media/600b6038045bf58b1af11af2_Vinovest-Q42020-Report.e138b0d9.pdf'
        }
    ];

    const readReport = (dateValue: string) => {
        PosthogHelper.captureEvent(AnalyticsEventNames.SelectPerformanceReport, { date: dateValue });
    };
    return (
        <div className={styles.Container}>
            <header className={styles.Hero}>
                <h1 className={styles.HeroHeading}>
                    <span>Historical Performance</span> Our Track Record
                </h1>
                <p className={styles.HeroText}>View completed and partial exits, or sales, Vinovest has made.</p>
                <Button
                    variant={'green'}
                    href={baseRoutes.signup.href}
                    font={'font-vinovest-medium'}
                    classnames={'text-16 !capitalize'}
                >
                    Start Investing
                </Button>
            </header>
            <ul className={styles.Stats}>
                <li>
                    $27,500,000+
                    <span>Capital Returned</span>
                </li>
                <li>
                    200,000+
                    <span>Clients</span>
                </li>
                <li>
                    1,700,000+
                    <span>Bottles Under Custody</span>
                </li>
            </ul>
            <section className={styles.Section}>
                <h2 className={styles.Heading2}>Recent Whiskey Exit</h2>
                <div className={styles.WhiskeyExit}>
                    <div className={styles.Description}>
                        <h3 className={styles.Heading3}>Whiskey exit</h3>
                        <p className={styles.Text}>
                            Recently, Vinovest offered high-rye bourbon casks to clients for $1,415 per barrel. Seven
                            months later, an alcoholic beverage producer inquired about buying those same casks at a
                            contract price of $1,850 each, resulting in a 30.7% return to investors.
                        </p>
                    </div>
                    <div className={styles.ImageContainer}>
                        <div className={styles.ImageBox}>
                            <Image src={WhiskeyExitImage} alt={'Whiskey Exit'} className={'whiskey-image-size'} />
                            <p>
                                The hold time and performance of casks may vary and are subject to market conditions.
                                The example provided is for illustrative purposes only and should not be considered as a
                                guarantee or prediction of future performance.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className={styles.Section}>
                <h2 className={styles.Heading2}>Recent Wine Exits</h2>
                <TrackRecordSection />
                <p className={`${styles.Disclaimer}`}>
                    Past exits are not indicative of future results. All results are net of storage and insurance costs.
                </p>
                <div className={styles.CtaContainer}>
                    <Button
                        variant={'green'}
                        href={baseRoutes.signup.href}
                        font={'font-vinovest-medium'}
                        classnames={'text-16 !capitalize'}
                    >
                        Start Investing
                    </Button>
                </div>
            </section>
            <section className={styles.Section}>
                <h2 className={styles.Heading2}>Performance Reports</h2>
                <p className={styles.SubText}>
                    Stay up to date on the ever-changing world of wine and whiskey investing. Our quarterly reports
                    analyze the biggest stories and latest trends impacting your wallet, and give you the insights you
                    need invest with confidence.
                </p>
                <div className={styles.ReportsList}>
                    {reports.map(({ q1Link, q2Link, q3Link, q4Link, year }) => (
                        <div className={styles.ReportsBox} key={year}>
                            <h3 className={styles.Heading3}>Quarterly reports {year}</h3>
                            <ol>
                                <li>
                                    <span className={'title'}>Q4 - {year}</span>
                                    <span className={'value'}>
                                        {q4Link ? (
                                            <a href={q4Link} onClick={() => readReport(`Q4_${year}`)}>
                                                Read Report
                                            </a>
                                        ) : (
                                            <p>Coming Soon</p>
                                        )}
                                    </span>
                                </li>
                                <li>
                                    <span className={'title'}>Q3 - {year}</span>
                                    <span className={'value'}>
                                        {q3Link ? (
                                            <a href={q3Link} onClick={() => readReport(`Q3_${year}`)}>
                                                Read Report
                                            </a>
                                        ) : (
                                            <p>Coming Soon</p>
                                        )}
                                    </span>
                                </li>
                                <li>
                                    <span className={'title'}>Q2 - {year}</span>
                                    <span className={'value'}>
                                        {q2Link ? (
                                            <a href={q2Link} onClick={() => readReport(`Q2_${year}`)}>
                                                Read Report
                                            </a>
                                        ) : (
                                            <p>Coming Soon</p>
                                        )}
                                    </span>
                                </li>
                                <li>
                                    <span className={'title'}>Q1 - {year}</span>
                                    <span className={'value'}>
                                        {q1Link ? (
                                            <a href={q1Link} onClick={() => readReport(`Q1_${year}`)}>
                                                Read Report
                                            </a>
                                        ) : (
                                            <p>Coming Soon</p>
                                        )}
                                    </span>
                                </li>
                            </ol>
                        </div>
                    ))}
                </div>
            </section>
            <GetStarted />
        </div>
    );
};
